<header class="card-header" @fadeIn (click)="edit = canEdit ? !edit : false" (bpHover)="showShadow = $event">
	<ng-content select="h3"></ng-content>
</header>

<content class="card-list">
	<ng-content></ng-content>
</content>
